<template>
  <layout-view
      navTitle="Фильтры"
  >
    <template v-slot:nav>
      <div class="px-4 pb-2">

        <date-interval name="Интервал" :valueFrom.sync="filter.dateFrom" :valueTo.sync="filter.dateTo" />

        <label-view title="Тип платежа">
            <template v-slot:content>
                <v-list class="pa-0" nav>
                    <v-list-item
                            v-for="key in Object.keys(types)" :key="key"
                            @click="filter.typesSelected.filter((v)=>v===key).length===0 ? filter.typesSelected.push(key) : filter.typesSelected = filter.typesSelected.filter((v)=>v!==key);"
                            class="mb-0"
                    >
                        <v-checkbox :value="filter.typesSelected.filter((v)=>v===key).length>0" class="mb-2" color="primary" dense hide-details="auto" />
                        <div>
                            <v-icon size="18" :color="types[key].color" class="mr-2">{{ types[key].icon }}</v-icon>
                            {{ types[key].name }}
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </label-view>
        
        <label-view title="Вид">
          <template v-slot:content>
            <v-btn block depressed color="silver" @click="groupByDay = !groupByDay">
              <template v-if="groupByDay">Список <v-icon class="ml-2" small> mdi-view-list-outline</v-icon></template>
              <template v-else>Группировка по дням <v-icon class="ml-2" small> mdi-group</v-icon></template>
            </v-btn>
          </template>
        </label-view>

        <label-view title="Способ расчета">
            <template v-slot:content>
                <v-list class="pa-0" nav>
                    <v-list-item
                            v-for="key in Object.keys(sources)" :key="key"
                            @click="filter.sourcesSelected.filter((v)=>v===key).length===0 ? filter.sourcesSelected.push(key) : filter.sourcesSelected = filter.sourcesSelected.filter((v)=>v!==key);"
                            class="mb-0"
                    >
                        <v-checkbox :value="filter.sourcesSelected.filter((v)=>v===key).length>0" class="mb-2" color="primary" dense hide-details="auto" />
                        <div>
                            <v-icon size="18" color="type.color" class="mr-2">{{ sources[key].icon }}</v-icon>
                            {{ sources[key].name }}
                        </div>
                    </v-list-item>
                </v-list>
            </template>
        </label-view>

        <device-cash-box-select class="mt-4 mb-4" @selected="(v)=>filter.kktNames = v ? v.split(',') : []" multiple/>

        <insur-select @selected="(i)=>filter.insursSelected = i" class="mb-3" selectAllEnabled/>

        <checkbox-field name="Не подтверждено" class="mb-4" :value.sync="filter.notAccepted"/>

        <user-autocomplete-multiple name="Клиент" :select.sync="filter.userClientsSelected"/>

        <com-branch-autocomplete-multiple :select.sync="filter.comBranchesSelected"/>

        <text-field name="Сумма" :value.sync="filter.amount"/>

        <text-field name="ID" :value.sync="filter.payId"/>

      </div>
    </template>
    <template v-slot:widgets>
      <v-row no-gutters>
        <v-col v-for="(v,i) in Object.keys(sources)" :key="i" cols="auto" class="mr-4">
          <v-sheet class="px-2 py-1" outlined rounded>
            <div class="caption">{{sources[v].name}}</div>
            <div>
              <v-progress-circular v-if="loadState.isLoading" size="16" width="2" indeterminate color="primary"/>
              <template v-else>{{$tools.price(collectFields[v] || 0)}}</template>
            </div>
          </v-sheet>
        </v-col>
        <v-col cols="auto" class="mr-4">
          <v-sheet class="px-2 py-1" outlined rounded>
            <div class="caption">Итого</div>
            <div>
              <v-progress-circular v-if="loadState.isLoading" size="16" width="2" indeterminate color="primary"/>
              <template v-else>{{$tools.price(collectFields.total || 0)}}</template>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </template>
    <template v-slot:content="{height}">
          <n-table-view
          :headers="[
            { text: 'ID', value: 'id', align: 'start', class:'text-no-wrap', sortable: true},
            { text: 'Дата', value: 'created', class:'text-no-wrap', sortable: true},
            { text: 'Время', value: 'created', class:'text-no-wrap', sortable:true },
            { text: 'Тип платежа', value: 'type', class:'text-no-wrap', sortable: true },
            { text: 'Способы расчета', value: 'source', class:'text-no-wrap', sortable: false },
            { text: 'Комментарий', value: 'comment', class:'text-no-wrap', sortable: false },
            { text: 'Кассир', value: 'operatorUser.lastName', class:'text-no-wrap', sortable: true },
            { text: 'Клиент', value: 'user.lastName', class:'text-no-wrap', sortable: true },
            { text: 'ID клиента', value: 'user.id', class:'text-no-wrap', sortable: true },
            { text: 'Фискальный регистратор', value: 'cashBox', class:'text-no-wrap', sortable: true },
            { text: 'Наименование организации', value: 'insur.name', class:'text-no-wrap', sortable: true },
            { text: 'Баланс личного счета', value:'accountBalance', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Наличные', value:'amountCash', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Банковская карта', value:'amountCard', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Расчётный счет', value:'amountBankAccount', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Личный счёт', value:'amountAccount', sortable: true, class:'text-no-wrap text-right'},
            { text: 'ОМС', value:'amountOms', sortable: true, class:'text-no-wrap text-right'},
            { text: 'ДМС', value:'amountDms', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Контракт', value:'amountContract', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Организация', value:'amountInsur', sortable: true, class:'text-no-wrap text-right'},
            { text: 'Итого', value: 'amount', class:'text-no-wrap', sortable: true }
          ]"
          ref="table"
          :genRequestBuilder="genRequestBuilder"
          :height="height"
          :groupBy="groupByDay ? 'group' : undefined"
        >
        <template v-slot:groupHeader="{ items, isOpen, toggle, headers }">

            <td :colspan="headers.length" @click="toggle">
              <div class="d-flex align-center subtitle-1" style="gap:20px">
                <v-icon>
                  {{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                </v-icon>
                {{ items[0].group }}

                <span>Количество: {{ items.length }}</span>
                
              <!-- заменить этот вариант, когда начнут приходить отрицательные значения -->
                <span>Итого: {{ $tools.price( 
                  items.reduce((sum, item) => {
                    const value = $tools.parseNumber(item.amount);
                    return sum + (
                      item.type === 'internalOut' || item.type === 'accountOut'
                        ? -value
                        : value
                    );
                  }, 0)
                ) }}
                </span>

                <!-- {{ $tools.price(items.reduce((sum, item) => sum +$tools.parseNumber(item.amount), 0)) }} -->
              </div>
            </td>
  
        </template>
        <template v-slot:barActions>
          <v-btn small depressed @click="internalInOutState.modalOpen({type:'internalIn',amount:null,comment:null,fiscal:false})" class="mr-2">
            <v-icon size="14" :color="types.internalIn.color" class="mr-2">{{ types.internalIn.icon }}</v-icon>Приход
          </v-btn>
          <v-btn small depressed @click="internalInOutState.modalOpen({type:'internalOut',amount:null,comment:null,fiscal:false})">
            <v-icon size="14" :color="types.internalOut.color" class="mr-2">{{ types.internalOut.icon }}</v-icon>Расход
          </v-btn>
          <dialog-view
              :title="internalInOutState.modalData==null ? '' : internalInOutState.modalData.type==='internalIn' ? 'Приход': 'Расход'"
              :open="internalInOutState.isModalOpen"
              @cancel="internalInOutState.modalClose()"
          >
            <template v-slot:content v-if="internalInOutState.modalData!==null">
              <v-form ref="internalInOutForm">
                <v-text-field label="Сумма" v-model="internalInOutState.modalData.amount" :rules="formFieldRules.required" class="mb-4" type="number" outlined ed dense hide-details="auto"/>
                <v-textarea label="Комментарий" v-model="internalInOutState.modalData.comment" :rules="formFieldRules.required" class="mb-4" rows="4" outlined dense auto-grow hide-details="auto"/>
                <!-- <v-select label="Касса" v-model="internalInOutState.modalData.cashBox" :items="cashBoxs" :rules="formFieldRules.required" outlined dense hide-details="auto" item-text="name" item-value="id"/> -->
                <device-cash-box-select class="mt-4 mb-4" @selected="(v)=>internalInOutState.modalData.kktName=v" required/>
                <checkbox-field name="Фискальная операция" :value.sync="internalInOutState.modalData.fiscal"/>
              </v-form>
            </template>
            <template v-slot:actions>
              <v-btn text color="primary" @click="internalInOutSubmit()" :loading="internalInOutState.isLoading">ОК</v-btn>
            </template>
          </dialog-view>
        </template>
        <template v-slot:item="{item}">
          <tr @click="payId=item.id">
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">{{$tools.date(item.created)}}</td>
            <td class="text-no-wrap">{{$tools.time(item.created)}}</td>
            <td class="text-no-wrap">
              <v-icon size="18" class="ml-n1 mr-2" :color="types[item.type].color">{{types[item.type].icon}}</v-icon>
              {{types[item.type].name}}
            </td>
            <td class="text-no-wrap">
              <pay-sources :pay="item" compact/>
            </td>
            <td class="text-no-wrap" :data-print="item.comment">
              <tooltip v-if="!$tools.isEmpty(item.comment)" bottom>              
                {{$tools.truncateText(item.comment,30)}}
                <template v-slot:content>
                  <vue-markdown>{{item.comment}}</vue-markdown>
                </template>
              </tooltip>
            </td>
            <td class="text-no-wrap">
              <UserFullName v-if="item.operatorUser" :user="item.operatorUser" :type="item.operatorUser.type"/>
            </td>
            <td class="text-no-wrap">
              <UserFullName v-if="item.user" :user="item.user"/>
            </td>
            <td class="text-no-wrap">          
              {{item.user?.id ? item.user.id : '-'}}       
            </td>
            <td class="text-no-wrap">
              <pay-devices :pay="{kktName:item.kktName}"/>
            </td>
            <td class="text-no-wrap">{{item.insur?.name ? item.insur?.name : '-'}}</td>
            <td class="text-no-wrap">{{item.type==="internalIn" || item.type==="internalOut" ? '' : $tools.price(item.accountBalance)}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountCash, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountCard, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountBankAccount, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountAccount, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountOms, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountDms, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountContract, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amountInsur, '-')}}</td>
            <td class="text-no-wrap">{{$tools.price(item.amount, '-')}}</td>
          </tr>
        </template>
      </n-table-view>
    </template>
    <template v-slot:footer>
      <pay :id="payId" @cancel="payId=null;$refs.table.load(true)"/>
    </template>
  </layout-view>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import axios from "axios";
import NTableView from "@/componentsV2/base/NTableView.vue";
import Pay from "@/views/Pay/Pay";
import moment from "moment";
import LayoutView from "@/components/LayoutView";
import PaySources from "@/views/Pay/components/PaySources.vue";
import PayDevices from "@/views/Pay/components/PayDevices.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import LabelView from "@/components/LabelView.vue";
import InsurSelect from "@/views/Insur/components/InsurSelect.vue";
import DeviceCashBoxSelect from "@/views/Device/component/DeviceCashBoxSelect.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import DateInterval from "@/componentsV2/base/DateInterval.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import CheckboxField from "@/componentsV2/base/CheckboxField.vue";
import {FormFieldRules} from "@/plugins/formFieldRules";
import DialogView from "@/components/DialogView";
import UserAutocompleteMultiple from "@/componentsV2/custom/UserAutocompleteMultiple.vue";
import ComBranchAutocompleteMultiple from "@/componentsV2/custom/ComBranchAutocompleteMultiple.vue";

import {
  Entity_User,
  Entity_Pay,
  Entity_Insur
} from "../../../EntityStoreCacheService";

export default {
  components: {
    DeviceCashBoxSelect, InsurSelect, LabelView,
    NTableView, UserFullName, PayDevices,
    PaySources,
    LayoutView,
    Pay,
    Tooltip, 
    DateInterval,
    TextField,
    CheckboxField,
    DialogView,
    UserAutocompleteMultiple,
    ComBranchAutocompleteMultiple
  },
  data: () => ({
    dateFrom:null,
    dateTo:null,
    types:Api.model.Pay.types,
    sources:Api.model.Pay.sources,
    payId:null,

    filter: {
      dateFrom:moment().format('DD.MM.YYYY'),
      dateTo:moment().format('DD.MM.YYYY'),
      typesSelected:[],
      sourcesSelected:[],
      insursSelected:[],
      kktNames: [],
      notAccepted: false,
      userClientsSelected:[],
      comBranchesSelected: [],
      amount: null,
      payId: null
    },

    internalInOutState:new State(),
    formFieldRules: FormFieldRules,

    loadState: new State(),
    collectFields: {},

    groupByDay: false
  }),
  mounted() {

  },
  watch:{
    filter: {
      deep: true,
      handler () {
        this.$refs.table.load();
      },
    },
  },
  methods:{
    genRequestBuilder(page, onPage, sortFields){
      let rb = new Entity_Pay()
      .selects(Entity_Pay.id)
      .selects(Entity_Pay.type)
      .selects(Entity_Pay.amount)
      .selects(Entity_Pay.amountPayed)
      .selects(Entity_Pay.amountCash)
      .selects(Entity_Pay.amountCard)
      .selects(Entity_Pay.amountBankAccount)
      .selects(Entity_Pay.amountAccount)
      .selects(Entity_Pay.amountOms)
      .selects(Entity_Pay.amountDms)
      .selects(Entity_Pay.amountContract)
      .selects(Entity_Pay.accountBalance)
      .selects(Entity_Pay.kktName)
      .selects(Entity_Pay.terminalName)
      .selects(Entity_Pay.tranId)
      .selects(Entity_Pay.comment)
      .selects(Entity_Pay.created)
      .selects(Entity_Pay.isAcceptBankAccount)
      .selects(Entity_Pay.isAcceptOms)
      .selects(Entity_Pay.isAcceptDms)
      .selects(Entity_Pay.isAcceptContract)

      .selects([Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.insur, Entity_Insur.id].join('.'))
      .selects([Entity_Pay.insur, Entity_Insur.name].join('.'))

      .collect(Entity_Pay.collect_sums)


      if(this.filter.dateFrom)  
        rb.filterAnd([Entity_Pay.entity, Entity_Pay.created].join('.')+'>=?',moment(this.filter.dateFrom, 'DD-MM-YYYY').format('YYYY-MM-DD 00:00:00'));
      
      if(this.filter.dateTo) 
        rb.filterAnd([Entity_Pay.entity, Entity_Pay.created].join('.')+'<=?',moment(this.filter.dateTo, 'DD-MM-YYYY').format('YYYY-MM-DD 23:59:59'));

      if (!this.$tools.isEmpty(this.filter.userClientsSelected))
        rb.filterAnd([Entity_Pay.entity, Entity_Pay.user, Entity_User.id].join('.') + ' in (?)',this.filter.userClientsSelected.map(i=>i.id))

      if (!this.$tools.isEmpty(this.filter.typesSelected))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.type].join('.')+' in (?)',this.filter.typesSelected);

      if (!this.$tools.isEmpty(this.filter.sourcesSelected)){
        let query = '';

        this.filter.sourcesSelected.forEach((source,idx)=>{
            let key = 'amount'+source[0].toUpperCase() + source.slice(1);
            let part = [Entity_Pay.entity, Entity_Pay[key]].join('.')+' > 0'

            query+= part
            if (idx!==this.filter.sourcesSelected.length-1)
              query+=' OR '
        })
        rb.filterAnd(query)
      }
        
      if (!this.$tools.isEmpty(this.filter.insursSelected))
          rb.filterAnd([Entity_Pay.entity, Entity_Pay.insur, Entity_Insur.id].join('.')+' in (?)', this.filter.insursSelected.map(i=>i.id))

      if (!this.$tools.isEmpty(this.filter.kktNames))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.kktName].join('.')+' in (?)',this.filter.kktNames);

      if (!this.$tools.isEmpty(this.filter.comBranchesSelected)) {
        let query = '';
        let params = [];
        this.filter.comBranchesSelected.forEach((comBranch,idx)=>{
            params.push([`%${comBranch.name.split(' ')[0]}%`]);
            let part = [Entity_Pay.entity, Entity_Pay.kktName].join('.')+ ' LIKE ?'

            query+= part
            if (idx!==this.filter.comBranchesSelected.length-1)
              query+=' OR '
        })
        rb.filterAnd(query,...params)
      }
       
      if (this.filter.notAccepted) {
        rb.filterAnd(
        [Entity_Pay.entity, Entity_Pay.amountBankAccount].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptBankAccount].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountContract].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptContract].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountDms].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptDms].join('.')+' = false OR '+ 
        [Entity_Pay.entity, Entity_Pay.amountOms].join('.')+' > 0 AND '+  
        [Entity_Pay.entity, Entity_Pay.isAcceptOms].join('.')+' = false')
      }

      if (!this.$tools.isEmpty(this.filter.amount))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.amount].join('.')+' =?',this.filter.amount);

      if (!this.$tools.isEmpty(this.filter.payId))
         rb.filterAnd([Entity_Pay.entity, Entity_Pay.id].join('.')+' =?',this.filter.payId);


      rb.page(page).onPage(onPage)

      sortFields.forEach(v=>{
          rb.order(v.field, v.isAsc)
      })

      rb.addStateCallback((v) => {
        v.items.forEach(i=>i.group = moment(i.created).format('DD.MM.YYYY'))
        this.loadState.setRequestBuilderState(v)
        if(this.loadState.isSuccess && v.collect)
          this.collectFields = v.collect.sums;
      })

      return rb;
    },
    internalInOutSubmit(){
      if (this.$refs.internalInOutForm.validate()){

        let loadUser = (success)=>{
          axios.get(Api.host+'/user/status/')
              .then((res)=> {
                axios.get(Api.host + '/user/' + res.data.id + '/')
                    .then((res) => {
                      success(res.data);
                    })
                    .catch(() => this.$store.commit('alertError', 'Ошибка загрузки информации о текущем пользователе'));
              });
        };
        let deviceFound = (name, success)=>{
            this.kkm.devices((arr)=>{
              let f = arr.filter(v=>v.name===name)
              if(f.length===0){
                this.$store.commit('alertError', 'Фискальный регистратор не найден');
              } else {
                success(f[0]);
              }
            }, ()=>{
              this.$store.commit('alertError', 'Ошибка подключения к фискальному регистратору');
            })
        };
        let register = ()=>{
          this.internalInOutState.stateLoading();
          axios.post(Api.host+'/pay/internal/', this.internalInOutState.modalData)
              .then(r =>{
                this.template = r.data;
                this.internalInOutState.stateSuccess();
                this.internalInOutState.modalClose();
                this.$refs.table.load(true);
              })
              .catch(e =>{
                Api.responseError(e)
                this.internalInOutState.stateError();
              });
        }

        if(this.internalInOutState.modalData.fiscal){
          deviceFound(this.internalInOutState.modalData.kktName, device=>{
            loadUser(user=>{

              if(this.internalInOutState.modalData.type==='internalIn')
                this.kkm.depositingCash(
                    device,
                    user.lastName + ' ' + user.firstName,
                    user.userProfile.inn,
                    this.internalInOutState.modalData.amount,
                    ()=>{
                      this.$store.commit('alertSuccess', 'Команда отправлена на фискальный регистратор');
                      register();
                    }, (e)=>{
                      this.$store.commit('alertError', 'Ошибка подключения к фискальному регистратору: '+e);
                    })

              if(this.internalInOutState.modalData.type==='internalOut')
                this.kkm.paymentCash(
                    device,
                    user.lastName + ' ' + user.firstName,
                    user.userProfile.inn,
                    this.internalInOutState.modalData.amount,
                    ()=>{
                      this.$store.commit('alertSuccess', 'Команда отправлена на фискальный регистратор');
                      register();
                    }, (e)=>{
                      this.$store.commit('alertError', 'Ошибка подключения к фискальному регистратору: '+e);
                    })
            })
          })
        } else {
          register();
        }
      }
    },
  }
}
</script>